import {
  create_x_d,
  update_x_d,
  delete_x_d,
  recover_x_d,
  query_x_d_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-xd-config';

import { reactive } from 'vue';
import { get_is_active, getDateTime, toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '下单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写下单号',
    },
    {
      type: 'remoteselect',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remoteselect',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: 'cxzc',
      disabled: false,
      placeholder: '请选择cxzc',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'cd_code',
      label: '撤单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写撤单编号',
    },
    {
      type: 'input',
      name: 'hd_code',
      label: '耗单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写耗单编号',
    },
    {
      type: 'input',
      name: 'k_t_d_code',
      label: '卡转单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡转单编号',
    },
    {
      type: 'input',
      name: 'k_t_d_code_gg',
      label: '公共卡转单',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写公共卡转单',
    },
    {
      type: 'remoteselect',
      name: 'k_id',
      label: '单对应的卡',
      disabled: false,
      placeholder: '请选择单对应的卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-gk',
    },
    {},
    {},
    {},
    {},
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    customer_id: null,
    staff_id: null,
    project_id: null,
    cxzc_id: null,
    shop_id: null,
    cd_code: null,
    hd_code: null,
    k_t_d_code: null,
    k_t_d_code_gg: null,
    k_id: null,
    is_cd: null,
    is_hd: null,
    is_kk_is_zf: null,
    is_k_t_d: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '下单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写下单号',
    },
    {
      type: 'remoteselect',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'rmjstore-customer',
    },
    {
      type: 'input',
      name: 'cd_code',
      label: '撤单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写撤单编号',
    },
    {
      type: 'input',
      name: 'hd_code',
      label: '耗单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写耗单编号',
    },
    {
      type: 'input',
      name: 'k_t_d_code',
      label: '卡转单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡转单编号',
    },
    {
      type: 'input',
      name: 'k_t_d_code_gg',
      label: '公共卡转单',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写公共卡转单',
    },
    {
      type: 'remoteselect',
      name: 'k_id',
      label: '单对应的卡',
      disabled: false,
      placeholder: '请选择单对应的卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-gk',
    },
    {
      type: 'remoteselect',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'input',
      name: 'project_cs',
      label: '项目次数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目次数',
    },
    {
      type: 'input',
      name: 'sy_project_cs',
      label: '项目剩余',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目剩余',
    },
    {
      type: 'input',
      name: 'project_price',
      label: '项目单价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目单价',
    },
    {
      type: 'input',
      name: 'project_je',
      label: '项目金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目金额',
    },
    {
      type: 'input',
      name: 'czje',
      label: '充值使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写充值使用金额',
    },
    {
      type: 'input',
      name: 'flje',
      label: '返利使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写返利使用金额',
    },
    {
      type: 'input',
      name: 'zjfl',
      label: '直接返利',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写直接返利',
    },
    {
      type: 'input',
      name: 'zjje',
      label: '赠券使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写赠券使用金额',
    },
    {},
    {
      type: 'input',
      name: 'is_ck',
      label: 'is_ck',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写is_ck',
    },
    {
      type: 'input',
      name: 'is_kk',
      label: 'is_kk',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写is_kk',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: 'cxzc',
      disabled: false,
      placeholder: '请选择cxzc',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'rmjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {
    customer_id: [{ required: true, message: '请填输入会员姓名' }],
    shop_id: [{ required: true, message: '请填输入执行门店' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    customer_id: null,
    cd_code: null,
    hd_code: null,
    k_t_d_code: null,
    k_t_d_code_gg: null,
    k_id: null,
    project_id: null,
    project_cs: null,
    sy_project_cs: null,
    project_price: null,
    project_je: null,
    czje: null,
    flje: null,
    zjfl: 0,
    zjje: 0,
    is_hd: null,
    is_ck: null,
    is_kk: null,
    cxzc_id: null,
    shop_id: null,
    staff_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '下单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写下单号',
    },
    {
      type: 'remoteselect',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'input',
      name: 'cd_code',
      label: '撤单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写撤单编号',
    },
    {
      type: 'input',
      name: 'hd_code',
      label: '耗单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写耗单编号',
    },
    {
      type: 'input',
      name: 'k_t_d_code',
      label: '卡转单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡转单编号',
    },
    {
      type: 'input',
      name: 'k_t_d_code_gg',
      label: '公共卡转单',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写公共卡转单',
    },
    {
      type: 'remoteselect',
      name: 'k_id',
      label: '单对应的卡',
      disabled: false,
      placeholder: '请选择单对应的卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-gk',
    },
    {
      type: 'remoteselect',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'input',
      name: 'project_cs',
      label: '项目次数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目次数',
    },
    {
      type: 'input',
      name: 'sy_project_cs',
      label: '项目剩余',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目剩余',
    },
    {
      type: 'input',
      name: 'project_price',
      label: '项目单价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目单价',
    },
    {
      type: 'input',
      name: 'project_je',
      label: '项目金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目金额',
    },
    {
      type: 'input',
      name: 'czje',
      label: '充值使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写充值使用金额',
    },
    {
      type: 'input',
      name: 'flje',
      label: '返利使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写返利使用金额',
    },
    {
      type: 'input',
      name: 'zjfl',
      label: '直接返利',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写直接返利',
    },
    {
      type: 'input',
      name: 'zjje',
      label: '赠券使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写赠券使用金额',
    },
    {},
    {
      type: 'input',
      name: 'is_ck',
      label: 'is_ck',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写is_ck',
    },
    {
      type: 'input',
      name: 'is_kk',
      label: 'is_kk',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写is_kk',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: 'cxzc',
      disabled: false,
      placeholder: '请选择cxzc',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    customer_id: null,
    cd_code: null,
    hd_code: null,
    k_t_d_code: null,
    k_t_d_code_gg: null,
    k_id: null,
    project_id: null,
    project_cs: null,
    sy_project_cs: null,
    project_price: null,
    project_je: null,
    czje: null,
    flje: null,
    zjfl: null,
    zjje: null,
    is_hd: null,
    is_ck: null,
    is_kk: null,
    cxzc_id: null,
    shop_id: null,
    staff_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '下单管理',
  addModalTitle: '新建下单',
  updateTitle: '修改下单',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    xd_id: 'id',
  },
  delete: {
    xd_id: 'id',
  },
  recover: {
    xd_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    xd_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '下单号',
    width: 150,
    fixed: 'left',
    dataIndex: 'order_code',
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    fixed: 'left',
    dataIndex: 'customer__name',
    checked: true,
  },
  {
    title: '项目名称',
    width: 150,
    fixed: 'left',
    dataIndex: 'project__name',
    checked: true,
  },
  {
    title: '购卡记录ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '撤单编号',
    width: 150,
    dataIndex: 'cd_code',
    checked: true,
  },
  {
    title: '耗单编号',
    width: 150,
    dataIndex: 'hd_code',
    checked: true,
  },
  {
    title: '卡转单编号',
    width: 150,
    dataIndex: 'k_t_d_code',
    checked: true,
  },
  {
    title: '公共卡转单',
    width: 150,
    dataIndex: 'k_t_d_code_gg',
    checked: true,
  },
  {
    title: '单对应的卡',
    width: 150,
    dataIndex: 'k_id',
    checked: false,
  },
  {
    title: '卡号',
    width: 150,
    dataIndex: 'k__order_code',
    checked: true,
  },
  {
    title: '客户ID',
    width: 150,
    dataIndex: 'customer_id',
    checked: false,
  },
  {
    title: '会员编号',
    width: 150,
    dataIndex: 'customer__code',
    checked: true,
  },
  {
    title: '项目ID',
    width: 150,
    dataIndex: 'project_id',
    checked: false,
  },
  {
    title: '项目次数',
    width: 150,
    dataIndex: 'project_cs',
    checked: true,
  },
  {
    title: '项目剩余',
    width: 150,
    dataIndex: 'sy_project_cs',
    checked: true,
  },
  {
    title: '换单价差',
    width: 150,
    dataIndex: 'diff_price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '项目单价',
    width: 150,
    dataIndex: 'project_price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '项目金额',
    width: 150,
    dataIndex: 'project_je',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '充值使用金额',
    width: 150,
    dataIndex: 'czje',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '返利使用金额',
    width: 150,
    dataIndex: 'flje',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '直接返利',
    width: 150,
    dataIndex: 'zjfl',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '赠券使用金额',
    width: 150,
    dataIndex: 'zjje',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '是否耗单',
    width: 150,
    dataIndex: 'is_hd',
    checked: true,

    slots: { customRender: 'bool' },
  },
  {
    title: '是否撤单',
    width: 150,
    dataIndex: 'is_cd',
    checked: true,

    slots: { customRender: 'bool' },
  },
  {
    title: '是否作废',
    width: 150,
    dataIndex: 'is_kk_is_zf',
    checked: true,

    slots: { customRender: 'bool' },
  },
  {
    title: '父单id',
    width: 150,
    dataIndex: 'parent',
    checked: true,
  },
  {
    title: '是否是卡转单',
    width: 150,
    dataIndex: 'is_k_t_d',
    checked: true,

    slots: { customRender: 'bool' },
  },
  {
    title: '政策ID',
    width: 150,
    dataIndex: 'cxzc_id',
    checked: false,
  },
  {
    title: '政策名称',
    width: 150,
    dataIndex: 'cxzc__name',
    checked: true,
  },
  {
    title: '员工编码',
    width: 150,
    dataIndex: 'staff__code',
    checked: true,
  },
  {
    title: '员工姓名',
    width: 150,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff_id',
    checked: false,
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop_id',
    checked: false,
  },
  {
    title: '门店名称',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: true,

    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },

  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_x_d_list,
    addData: create_x_d,
    updateData: update_x_d,
    removeData: delete_x_d,
    recoverData: recover_x_d,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
